import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TPlatformAgreementDetails, TPlatformUseGetData } from "../types/customers";

type TinitialState = {
    cashPlatforUseAgreeData: TPlatformUseGetData[];
    addCashPlatformAgreement: TPlatformAgreementDetails;
    selectedCashUsePlatform: TPlatformUseGetData | null;
    createCashAgreement: boolean;
    cashAgreementTabs: TPlatformUseGetData[];
    isEditCashAgre: boolean
};
const initialState: TinitialState = {
    cashPlatforUseAgreeData: [],
    addCashPlatformAgreement: {
        id: 0,
        traderId: 0,
        traderName: "",
        traderMobile: "",
        traderEmail: "",
        companyName: "",
        companyMobile: "",
        companyEmail: "",
        status: "",
        cuatomerSignedOn: "",
        companySignedOn: "",
        executedOn: "",
        type: "",
        isNew: false,
        tradeName: "",
        signerName: "",
        traderAddress: {
            city: "",
            country: '',
            locality: "",
            pincode: "",
            state: "",
            street_address: ""
        }
    },
    selectedCashUsePlatform: null,
    createCashAgreement: false,
    cashAgreementTabs: [],
    isEditCashAgre: false
};
const cashPfUseAgreement = createSlice({
    name: "cashPfUseAgreement",
    initialState: initialState,
    reducers: {
        setCashPlatforUseAgreeData: (state, action: PayloadAction<TPlatformUseGetData[]>) => {
            state.cashPlatforUseAgreeData = action.payload
        },

        setAddCashPlatformAgreement: (
            state,
            action: PayloadAction<{
                cashId: number;
            }>
        ) => {
            state.addCashPlatformAgreement = {
                traderId: action.payload.cashId,
                id: 0,
                traderName: "",
                traderMobile: "",
                traderEmail: "",
                companyName: "Rama Rao Kancharapu",
                companyMobile: "8337922222",
                companyEmail: "rama@onoark.com",
                status: "",
                cuatomerSignedOn: "",
                companySignedOn: "",
                executedOn: "",
                type: "",
                isNew: false,
                tradeName: "",
                traderAddress: {
                    city: "",
                    country: "INDIA",
                    locality: "",
                    pincode: "",
                    state: "",
                    street_address: "",
                },
                signerName: "",
            };
        },
        updateCashPlatformUseDetails: (
            state,
            action: PayloadAction<{
                addCashPlatformAgreement: TPlatformAgreementDetails;
            }>
        ) => {
            state.addCashPlatformAgreement = action.payload.addCashPlatformAgreement;
        },
        setSelectedCashPlatformUse: (
            state,
            action: PayloadAction<TPlatformUseGetData>
        ) => {
            state.selectedCashUsePlatform = action.payload;
        },
        setCreateCashAgreement: (state, action: PayloadAction<boolean>) => {
            state.createCashAgreement = action.payload
        },
        setCashAgreementTabs: (state, action: PayloadAction<TPlatformUseGetData[]>) => {
            state.cashAgreementTabs = action.payload
        },
        setIsEditCashAgree: (state, action: PayloadAction<boolean>) => {
            state.isEditCashAgre = action.payload;
        },
    },
});

export const {
    setCashPlatforUseAgreeData,
    setAddCashPlatformAgreement,
    updateCashPlatformUseDetails,
    setSelectedCashPlatformUse,
    setCreateCashAgreement,
    setCashAgreementTabs,
    setIsEditCashAgree
} = cashPfUseAgreement.actions;
export default cashPfUseAgreement.reducer;
